/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorRecommendedArticles from 'base/components/labrador/RecommendedArticles';

export const DynamicLabradorRecommendedArticles: typeof LabradorRecommendedArticles = (props) => {
    return <ErrorBoundary><LabradorRecommendedArticles {...props} /></ErrorBoundary>;
}
export type DynamicLabradorRecommendedArticlesProps = PropsFromComponent<typeof LabradorRecommendedArticles>;
